import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { JackingCancelModalComponent } from './jacking-cancel-modal.component';
import {SharedModule} from '../../../../shared/shared.module';
import {TextMaskModule} from 'angular2-text-mask';
import {DirectivesModule} from '../../../../../directives/directives.module';
import {ErrorsPageModule} from '../../../../shared/components/errors-page/errors-page.module';

@NgModule({
  declarations: [
    JackingCancelModalComponent
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(JackingCancelModalComponent),
    SharedModule,
    TextMaskModule,
    ErrorsPageModule
  ],
})
export class JackingCancelModalComponentModule {}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/components/jacking-cancel-modal/jacking-cancel-modal.component.module.ts